// 后台业务操作：简体中文字段。只维护显示文案，不改业务标识、数值或提交内容。
// 管理流程
export const flows = Object.freeze({
  "adminFlows.loading": "加载中...",
  "adminFlows.updating": "修改中...",
  "adminFlows.publishing": "发布中...",
  "adminFlows.recognizedAndFilledCountProducts": "已识别并填充 {count} 条商品",
  "adminFlows.noProductDetailsTheOrderCannotBePlaced":
    "商品明细为空，暂时无法下单",
  "adminFlows.someProductSpecificationsAreNoLongerAvailableGoBackAndSelectAgain":
    "部分商品规格已失效，请返回重新选择",
  "adminFlows.completeTheProductInformation": "请填写完整的商品信息！",
  "adminFlows.enterTheBrand": "请填写品牌",
  "adminFlows.enterAPartNumber": "请填写料号",
  "adminFlows.enterAPriceGreaterThanZero": "请填写大于0的价格",
  "adminFlows.enterTheQuantity": "请填写数量",
  "adminFlows.enterAQuantityGreaterThanZero": "请填写大于0的数量",
  "adminFlows.membershipLevels": "会员等级列表",
  "adminFlows.levelName": "等级名称",
  "adminFlows.requiredPoints": "所需积分",
  "adminFlows.tradeDiscount": "交易折扣",
  "adminFlows.members": "会员人数",
  "adminFlows.benefits": "权益说明",
  "adminFlows.status": "状态",
  "adminFlows.enabled": "启用",
  "adminFlows.disabled": "停用",
  "adminFlows.actions": "操作",
  "adminFlows.edit": "编辑",
  "adminFlows.delete": "删除",
  "adminFlows.levelApplications": "等级申请记录",
  "adminFlows.assignLevel": "指定等级",
  "adminFlows.applicant": "申请人",
  "adminFlows.currentLevel": "当前等级",
  "adminFlows.requestedLevel": "申请等级",
  "adminFlows.applicationReason": "申请理由",
  "adminFlows.appliedAt": "申请时间",
  "adminFlows.approve": "通过",
  "adminFlows.reject": "拒绝",
  "adminFlows.membershipBenefits": "等级权益管理",
  "adminFlows.requiredPointsLabel": "所需积分：",
  "adminFlows.tradeDiscountLabel": "交易折扣：",
  "adminFlows.memberCountLabel": "会员人数：",
  "adminFlows.benefitsLabel": "权益说明：",
  "adminFlows.assignMembershipLevel": "指定会员等级",
  "adminFlows.selectMember": "选择成员",
  "adminFlows.selectASalesperson": "请选择业务员",
  "adminFlows.targetLevel": "目标等级",
  "adminFlows.selectALevel": "请选择等级",
  "adminFlows.reason": "设置理由",
  "adminFlows.enterAReason": "请输入设置理由",
  "adminFlows.cancel": "取消",
  "adminFlows.confirmAssignment": "确认指定",
  "adminFlows.editMembershipLevel": "编辑会员等级",
  "adminFlows.enterRequiredPoints": "请输入所需积分",
  "adminFlows.selectADiscount": "请选择折扣",
  "adminFlows.enterBenefitDetails": "请输入权益说明",
  "adminFlows.saveChanges": "保存修改",
  "adminFlows.unableToLoadMembershipLevelsPleaseTryAgain":
    "会员等级数据加载失败，请稍后重试",
  "adminFlows.approved": "已通过",
  "adminFlows.rejected": "已拒绝",
  "adminFlows.pendingReview": "审核中",
  "adminFlows.selectAMemberAndTargetLevel": "请选择成员和目标等级",
  "adminFlows.membershipLevelAssigned": "已成功指定会员等级",
  "adminFlows.completeTheRequiredInformation": "请填写完整的信息",
  "adminFlows.membershipLevelUpdated": "等级修改成功",
  "adminFlows.notice": "提示",
  "adminFlows.confirm": "确定",
  "adminFlows.deletedSuccessfully": "删除成功",
  "adminFlows.levelApplicationApproved": "已通过等级申请",
  "adminFlows.levelApplicationRejected": "已拒绝该申请",
  "adminFlows.noDiscount": "无折扣",
  "adminFlows.discount99": "99折",
  "adminFlows.discount98": "98折",
  "adminFlows.discount97": "97折",
  "adminFlows.discount95": "95折",
  "adminFlows.discount93": "93折",
  "adminFlows.discount9": "9折",
  "adminFlows.discount88": "88折",
  "adminFlows.discount85": "85折",
  "adminFlows.membershipIdentities": "会员身份列表",
  "adminFlows.identityName": "身份名称",
  "adminFlows.participantCount": "人数",
  "adminFlows.defaultLevel": "默认等级",
  "adminFlows.maximumLevel": "最高等级",
  "adminFlows.permissions": "权限说明",
  "adminFlows.createdAt": "创建时间",
  "adminFlows.salespersonManagement": "业务员管理",
  "adminFlows.account": "账号",
  "adminFlows.name": "姓名",
  "adminFlows.company": "所属公司",
  "adminFlows.mobileNumber": "手机号",
  "adminFlows.membershipLevel": "会员等级",
  "adminFlows.active": "正常",
  "adminFlows.frozen": "冻结",
  "adminFlows.unfreeze": "解冻",
  "adminFlows.customerManagement": "客户管理",
  "adminFlows.contact": "联系人",
  "adminFlows.companyName": "公司名称",
  "adminFlows.transactions": "交易次数",
  "adminFlows.supplierManagement": "供应商管理",
  "adminFlows.supplierName": "供应商名称",
  "adminFlows.supplyType": "供应类型",
  "adminFlows.yearsOfCooperation": "合作年限",
  "adminFlows.partnerManagement": "合作伙伴管理",
  "adminFlows.partnerName": "合作方名称",
  "adminFlows.cooperationType": "合作类型",
  "adminFlows.enterAContactName": "请输入联系人",
  "adminFlows.enterACompanyName": "请输入公司名称",
  "adminFlows.enterAMobileNumber": "请输入手机号",
  "adminFlows.selectAMembershipLevel": "请选择会员等级",
  "adminFlows.enterASupplyType": "请输入供应类型",
  "adminFlows.enterACooperationType": "请输入合作类型",
  "adminFlows.editIdentity": "编辑身份",
  "adminFlows.selectADefaultLevel": "请选择默认等级",
  "adminFlows.selectAMaximumLevel": "请选择最高等级",
  "adminFlows.salesperson": "业务员",
  "adminFlows.customer": "客户",
  "adminFlows.supplier": "供应商",
  "adminFlows.partner": "合作伙伴",
  "adminFlows.member": "成员",
  "adminFlows.unableToLoadMembershipIdentitiesPleaseTryAgain":
    "会员身份数据加载失败，请稍后重试",
  "adminFlows.updatedSuccessfully": "修改成功",
  "adminFlows.deleteThisIdentity": "确定要删除该身份吗？",
  "adminFlows.enterTheContactNameAndMobileNumber": "请填写联系人和手机号",
  "adminFlows.myCustomers": "我的客户",
  "adminFlows.customerId": "客户ID",
  "adminFlows.customerName": "客户名称",
  "adminFlows.noCustomersYet": "暂无客户信息",
  "adminFlows.findCustomers": "获取客户",
  "adminFlows.myOrders": "我的订单",
  "adminFlows.period": "期数",
  "adminFlows.brand": "品牌",
  "adminFlows.partNumber": "料号",
  "adminFlows.type": "类型",
  "adminFlows.bidPrice": "竞标价格",
  "adminFlows.bidQuantity": "竞标数量",
  "adminFlows.bidTime": "竞标时间",
  "adminFlows.pcs": "件",
  "adminFlows.noOrdersYet": "暂无订单记录",
  "adminFlows.viewBidding": "查看竞标",
  "adminFlows.unableToLoadCustomers": "客户列表加载失败",
  "adminFlows.biddingOpen": "竞标中",
  "adminFlows.pendingOpening": "待开标",
  "adminFlows.won": "已中标",
  "adminFlows.notWon": "未中标",
  "adminFlows.biddingClosed": "已截标",
  "adminFlows.opened": "已开标",
  "adminFlows.back": "返回",
  "adminFlows.productInformation": "产品信息",
  "adminFlows.aiRecognition": "智能识别",
  "adminFlows.enterTextOrPasteAProductImage": "请输入文本或粘贴产品图片内容",
  "adminFlows.recognitionImagePreview": "识别图片预览",
  "adminFlows.imageRecognition": "图片识别",
  "adminFlows.speechRecognition": "语音识别",
  "adminFlows.recognizeAndFill": "识别并填充",
  "adminFlows.orderType": "订单类型",
  "adminFlows.privateOrder": "专属订单",
  "adminFlows.sendToASpecificBuyerEnterTheBuyerPhoneNumber":
    "指定买家接收订单，选择后需要填写买家电话",
  "adminFlows.buyerPhone": "买家电话",
  "adminFlows.enterTheBuyerPhoneNumber": "请填写买家电话",
  "adminFlows.publicOrder": "公开订单",
  "adminFlows.publishPubliclyWithoutASpecificBuyerPhoneNumber":
    "发布为公开订单，无需指定买家电话",
  "adminFlows.productCategory": "产品分类",
  "adminFlows.selectAProductCategory": "请选择产品分类",
  "adminFlows.uploadImages": "上传图片",
  "adminFlows.dragToUploadOrReorderDoubleClickToPreview":
    "（支持拖拽上传、拖拽排序，双击放大预览）",
  "adminFlows.uploadProductImages": "上传产品图片",
  "adminFlows.productName": "产品名称",
  "adminFlows.enterAProductName": "请填写产品名称",
  "adminFlows.enterABrandName": "请填写品牌名称",
  "adminFlows.selectBrand": "选择品牌",
  "adminFlows.unitPrice": "单价",
  "adminFlows.enterAUnitPrice": "请输入单价",
  "adminFlows.approx": "约",
  "adminFlows.quantityUnit": "数量/单位",
  "adminFlows.enterQuantity": "请输入数量",
  "adminFlows.enterUnit": "填写单位",
  "adminFlows.deliveryAddress": "交货地址",
  "adminFlows.enterADeliveryAddress": "请填写交货地址",
  "adminFlows.dateCodeDc": "批次(DC)",
  "adminFlows.enterADateCode": "请填写批次",
  "adminFlows.goodsCondition": "货物情况",
  "adminFlows.multipleSelection": "（多选）",
  "adminFlows.noCategoryAttributesSelectASubcategory":
    "暂无分类属性，请选择二级分类",
  "adminFlows.additionalInformation": "补充信息",
  "adminFlows.expand": "展开",
  "adminFlows.datasheet": "规格书",
  "adminFlows.uploadDatasheet": "上传规格书",
  "adminFlows.manufacturer": "厂家",
  "adminFlows.enterAManufacturer": "请填写厂家",
  "adminFlows.weight": "重量",
  "adminFlows.enterWeight": "请填写重量",
  "adminFlows.g": "克",
  "adminFlows.dimensions": "尺寸",
  "adminFlows.length": "长度",
  "adminFlows.mm": "毫米",
  "adminFlows.width": "宽度",
  "adminFlows.height": "高度",
  "adminFlows.alternativeProducts": "替代产品",
  "adminFlows.addAlternativeProduct": "添加替代产品",
  "adminFlows.applications": "应用领域",
  "adminFlows.separateWithSpacesOrCommasPressEnterToConfirm":
    "用空格或逗号分开，按回车确认",
  "adminFlows.minimumOrderQuantity": "起订量",
  "adminFlows.enterMinimumOrderQuantity": "请填写起订量",
  "adminFlows.validUntil": "有效期",
  "adminFlows.selectValidityDate": "请选择有效期",
  "adminFlows.leadTime": "交货天数",
  "adminFlows.enterEstimatedLeadTime": "请填写预计交货天数",
  "adminFlows.businessDays": "工作日",
  "adminFlows.ownerCompany": "货主公司",
  "adminFlows.enterTheGoodsOwnerCompanyName": "请填写货主公司名称",
  "adminFlows.remarks": "备注",
  "adminFlows.enterProductRemarks": "请填写产品信息备注",
  "adminFlows.collapse": "收起",
  "adminFlows.purchaseRequirements": "需求信息",
  "adminFlows.productPrice": "商品价格",
  "adminFlows.enterProductPrice": "请填写商品价格",
  "adminFlows.quantity": "数量",
  "adminFlows.enterPurchaseQuantity": "请填写购买数量",
  "adminFlows.buyerInformation": "买家信息",
  "adminFlows.companyNameRequired": "请填写公司名称",
  "adminFlows.taxId": "税号",
  "adminFlows.enterATaxId": "请填写税号",
  "adminFlows.contactNameRequired": "请填写联系人",
  "adminFlows.contactDetails": "联系方式",
  "adminFlows.enterContactDetails": "请填写联系方式",
  "adminFlows.uploadOrderInformation": "上传订单信息",
  "adminFlows.orderInformation": "订单信息",
  "adminFlows.saveDraft": "暂存",
  "adminFlows.searchByCategoryName": "请输入分类名称搜索",
  "adminFlows.selectDate": "选择年月日",
  "adminFlows.selectADate": "请选择日期",
  "adminFlows.publishFeaturedProduct": "精选发布页面",
  "adminFlows.useAvailableDetailsToPublishAProductQuickly":
    "选填已有信息，快速发布商品",
  "adminFlows.confirmPublication": "确认发布",
  "adminFlows.quickOrder": "快捷下单",
  "adminFlows.editFeaturedProduct": "编辑精选商品",
  "adminFlows.updateProductDetailsAndSubmitForReview": "修改商品信息并提交审核",
  "adminFlows.confirmChanges": "确认修改",
  "adminFlows.required": "必填项",
  "adminFlows.enterAValidNumber": "请填写有效的数字",
  "adminFlows.enterAPositiveInteger": "请输入正整数",
  "adminFlows.cannotBeEmpty": "不能为空",
  "adminFlows.selectGoodsCondition": "请选择货物情况",
  "adminFlows.datasheetAttachment": "规格书附件",
  "adminFlows.pleaseSignInFirst": "请先登录",
  "adminFlows.onlyJpgPngAndWebpImagesAreSupported":
    "只支持 JPG、PNG、WEBP 图片",
  "adminFlows.imageMustNotExceed10Mb": "图片不能超过 10MB",
  "adminFlows.speechRecognitionIsNotSupportedByThisBrowser":
    "当前浏览器不支持语音识别",
  "adminFlows.speechRecognitionFailedPleaseTryAgain": "语音识别失败，请重试",
  "adminFlows.enterTextOrSelectAnImageFirst": "请先输入文字或选择图片",
  "adminFlows.noUsableProductInformationRecognized": "未识别到可填充的产品信息",
  "adminFlows.recognizedAndFilledSuccessfully": "识别并填充成功",
  "adminFlows.recognitionFailedPleaseTryAgain": "识别失败，请重试",
  "adminFlows.unableToLoadProductInformation": "商品信息加载失败",
  "adminFlows.unableToLoadProductInformationPleaseTryAgain":
    "商品信息加载失败，请稍后重试",
  "adminFlows.quickOrderCreated": "快捷下单成功！",
  "adminFlows.draftSaved": "内容暂存成功！",
  "adminFlows.selectAnOrderType": "请选择订单类型",
  "adminFlows.selectAValidOrderType": "请选择有效的订单类型",
  "adminFlows.publishedSuccessfully": "发布成功",
  "adminFlows.completeAllInformation": "请填写完整信息！",
  "adminFlows.selectASubcategory": "请选择二级分类",
  "adminFlows.enterAnAlternativeBrand": "请填写替代品牌",
  "adminFlows.enterAnAlternativePartNumber": "请填写替代料号",
  "adminFlows.suggestedTags": "常用标签：",
  "adminFlows.computers": "电脑",
  "adminFlows.mobilePhones": "手机",
  "adminFlows.automotive": "汽车",
  "adminFlows.iot": "物联网",
  "adminFlows.networking": "网络",
  "adminFlows.hongKongChina": "中国香港",
  "adminFlows.mainlandChina": "中国大陆",
  "adminFlows.newAndOriginal": "全新原装",
  "adminFlows.original": "原装",
  "adminFlows.salvaged": "拆机",
  "adminFlows.newLoosePackaging": "散新",
  "adminFlows.deleteMembershipLevelConfirmation": "确定要删除 {level} 等级吗？",
  "adminFlows.approveLevelApplicationConfirmation":
    "确定通过 {name} 的等级申请？",
  "adminFlows.rejectLevelApplicationConfirmation":
    "确定拒绝 {name} 的等级申请？",
  "adminFlows.levelPointsOption": "{level} (积分>={points})",
  "adminFlows.editType": "编辑{type}",
  "adminFlows.entityActionConfirmation": "确定要{action}该{type}吗？",
  "adminFlows.actionCompleted": "{action}成功",
  "adminFlows.deleteEntityConfirmation": "确定要删除该{type}吗？",
  "adminFlows.enterField": "请输入{field}",
  "adminFlows.certificateOfOriginCount": "原产地证明{count}",
  "adminFlows.recognizedCountProductsOnlyTheFirstIsFilled":
    "识别到 {count} 条产品，当前仅填充第一条",
  "adminFlows.upToMaxTagsAreAllowed": "最多只能添加{max}个标签",
});

// 数据看板：只维护显示文字，不改变原始工作表、筛选值或业务数据。
export const reportDashboard = Object.freeze({
  "reportDashboard.title": "业务数据看板",
  "reportDashboard.summaryHint":
    "仅统计交易完成订单 · 按订单创建日期 · 人民币待分类且不重复计入",
  "reportDashboard.dataSource": "数据来源",
  "reportDashboard.remoteSource": "后端查询",
  "reportDashboard.reportType": "报表类型",
  "reportDashboard.salesDashboard": "销售额看板",
  "reportDashboard.purchaseDashboard": "采购成本看板",
  "reportDashboard.exportFiltered": "导出筛选结果",
  "reportDashboard.viewDenied": "当前账号无该类数据看板权限",
  "reportDashboard.filters": "看板筛选",
  "reportDashboard.allCompanies": "全部本方公司",
  "reportDashboard.startDate": "订单创建起日",
  "reportDashboard.endDate": "止日",
  "reportDashboard.allCustomers": "全部客户",
  "reportDashboard.allSuppliers": "全部供应商",
  "reportDashboard.allModels": "全部料号",
  "reportDashboard.businessSource": "业务分类",
  "reportDashboard.allSources": "全部业务",
  "reportDashboard.cnySource": "人民币业务／待分类",
  "reportDashboard.usdSource": "美金业务",
  "reportDashboard.allCurrencies": "全部币种",
  "reportDashboard.cnyCurrency": "人民币 CNY",
  "reportDashboard.usdCurrency": "美元 USD",
  "reportDashboard.unitPlaceholder": "数量单位（可选）",
  "reportDashboard.keywordPlaceholder": "订单号／料号／商品名称",
  "reportDashboard.search": "查询",
  "reportDashboard.reset": "重置",
  "reportDashboard.facetsTruncated": "筛选项仅显示前100项，请缩小条件后查询。",
  "reportDashboard.readFailureHint":
    "查询失败，不会回退Excel或演示数据。下方若有内容，为上一次成功查询结果。",
  "reportDashboard.reading": "正在读取…",
  "reportDashboard.filtersChanged":
    "筛选已变更，请点击查询。当前仍为上一次结果。",
  "reportDashboard.generatedAt": "概览查询时间 {time}（各次查询时间独立）",
  "reportDashboard.notRead": "尚未读取",
  "reportDashboard.overview": "业务概览",
  "reportDashboard.salesDetailCount": "销售明细条数",
  "reportDashboard.purchaseDetailCount": "采购明细条数",
  "reportDashboard.customerCount": "合作客户主体数",
  "reportDashboard.supplierCount": "合作供应商主体数",
  "reportDashboard.quantityTotal": "商品总数量 · {unit}",
  "reportDashboard.salesAmount": "销售额",
  "reportDashboard.purchaseCost": "采购成本",
  "reportDashboard.missingDataWarning":
    "部分明细缺少金额或客户主体，请核对源订单；缺失值不补为真实金额。",
  "reportDashboard.monthlyTrend": "月度商品数量趋势",
  "reportDashboard.selectUnit": "选择单位",
  "reportDashboard.trendAccessibleLabel":
    "月度数量趋势，单位{unit}，币种{currency}",
  "reportDashboard.noTrend": "当前单位与币种暂无趋势数据",
  "reportDashboard.trendHint":
    "趋势只绘制同一单位、同一币种；金额不在浏览器重新汇总。",
  "reportDashboard.customerRanking": "客户金额排行",
  "reportDashboard.supplierRanking": "供应商金额排行",
  "reportDashboard.unknownCounterparty": "未标识主体",
  "reportDashboard.noRanking": "暂无排行",
  "reportDashboard.completedDetails": "成功订单明细",
  "reportDashboard.paginationSummary":
    "共 {total} 条 · 当前第 {page} 页 · 查询时间 {time}",
  "reportDashboard.noRecords": "当前条件下没有交易完成订单",
  "reportDashboard.orderNumber": "订单号",
  "reportDashboard.createdAt": "订单创建日期",
  "reportDashboard.ownCompany": "本方公司",
  "reportDashboard.customer": "客户",
  "reportDashboard.supplier": "供应商",
  "reportDashboard.partNumber": "料号",
  "reportDashboard.goodsName": "商品名称",
  "reportDashboard.quantity": "商品数量",
  "reportDashboard.amount": "成交金额",
  "reportDashboard.counterpartyId": "客户/供应商ID",
  "reportDashboard.counterparty": "客户/供应商",
  "reportDashboard.quantityUnit": "数量单位",
  "reportDashboard.currency": "币种",
  "reportDashboard.exactAmount": "成交金额（精确十进制）",
  "reportDashboard.salesSheet": "销售明细",
  "reportDashboard.purchaseSheet": "采购明细",
  "reportDashboard.exportFilename": "成功订单看板明细.xlsx",
  "reportDashboard.unitPieces": "件",
  "reportDashboard.unitTrays": "盘",
  "reportDashboard.unitUnknown": "未标识单位",
  "reportDashboard.readFailed": "看板读取失败",
  "reportDashboard.recordsFailed": "明细读取失败",
  "reportDashboard.exportFailed": "看板导出失败，请重试",
  "reportDashboard.companiesFailed": "公司列表加载失败",
  "reportDashboard.companiesInvalid": "公司列表返回格式不正确",
  "reportDashboard.workbookInvalid": "报表接口未返回有效的 Excel 文件",
  "reportDashboard.workbookEmpty": "报表接口返回了空文件",
  "reportDashboard.responseInvalid": "看板数据返回格式错误",
  "reportDashboard.invalidPart": "无效的看板读取类型",
  "reportDashboard.exportInvalid": "看板导出未返回有效文件",
  "reportDashboard.errorLoginRequired": "请先登录",
  "reportDashboard.errorNoAccess": "当前账号无数据看板权限",
  "reportDashboard.errorInvalidReportType": "报表类型错误",
  "reportDashboard.errorReportTypeForbidden": "无权查看该类报表",
  "reportDashboard.errorNoCompanyScope": "未配置可查看的公司范围",
  "reportDashboard.errorCompanyForbidden": "公司不在授权范围内",
  "reportDashboard.errorDateOrderInvalid": "起始日期不能晚于结束日期",
  "reportDashboard.errorPageInvalid": "分页参数超出范围",
  "reportDashboard.errorCurrencyInvalid": "币种无效",
  "reportDashboard.errorSourceInvalid": "业务分类无效",
  "reportDashboard.errorSourceCurrencyConflict": "业务分类与币种冲突",
  "reportDashboard.errorCustomerInvalid": "客户主体无效",
  "reportDashboard.errorDateRangeInvalid": "日期超出数据库支持范围",
  "reportDashboard.errorDateFormatInvalid": "日期必须为有效的yyyy-MM-dd格式",
  "reportDashboard.errorFilterTooLong": "筛选条件过长",
  "reportDashboard.errorTrendLimitExceeded":
    "趋势范围过大，请缩小时间或单位范围",
  "reportDashboard.errorExportLimitExceeded": "导出超过10000条，请缩小筛选范围",
  "reportDashboard.errorUnavailable": "看板数据暂时不可用，请重试",
  "reportDashboard.errorInvalidArgument": "看板请求参数无效，请检查后重试",
  "reportDashboard.errorFailed": "看板操作失败，请稍后重试",
  "reportDashboard.viewLoadingData": "数据加载中",
  "reportDashboard.viewDataLoaded": "数据已载入",
  "reportDashboard.viewValue0ItemsToCheck": "{value0} 项待核对",
  "reportDashboard.viewServerReports": "后端报表",
  "reportDashboard.viewSelectReport": "查看报表",
  "reportDashboard.viewAddData": "新增数据",
  "reportDashboard.viewUploadExcel": "上传 Excel",
  "reportDashboard.viewRefreshData": "刷新数据",
  "reportDashboard.viewLoadSourceWorksheetsForChecking": "按需读取原工作表核对",
  "reportDashboard.viewExportCurrentData": "导出当前数据",
  "reportDashboard.viewCouldNotLoadReportData": "报表数据加载失败",
  "reportDashboard.viewFiltersHaveChangedPreparingNewResultsOrWaitingForACompletePeriodPreviousResultsAreStillShown":
    "筛选范围已变更，正在准备新结果或等待完整周期；现有内容为上次查询结果。",
  "reportDashboard.viewLiveStatisticsUseCompletedOrderJSONDataLegacyExcelWorksheetsAreLoadedOnlyForCheckingNotForSalesTotalsRankingsOrTrendsCNYBusinessRemainsUnclassifiedTaxIsNotInferred":
    "真实看板使用成功订单JSON统计；旧Excel工作表仅按需读取核对，不参与本页销售额、排行及趋势。人民币暂列待分类，不推算税额。",
  "reportDashboard.viewFilters": "筛选条件",
  "reportDashboard.viewFilterTheDashboardByTimeValue0AndValue1Model":
    "按时间、{value0}和{value1}型号联动查看看板",
  "reportDashboard.viewClearFilters": "清除筛选",
  "reportDashboard.viewDateRange": "时间范围",
  "reportDashboard.viewSelectPeriod": "选择周期",
  "reportDashboard.viewSelectAPeriod": "请选择周期",
  "reportDashboard.viewCustomDates": "自定义日期",
  "reportDashboard.viewTo": "至",
  "reportDashboard.viewStartDate": "开始日期",
  "reportDashboard.viewEndDate": "结束日期",
  "reportDashboard.viewValue0Model": "{value0}型号",
  "reportDashboard.viewQuantityChartUnit": "数量图表单位",
  "reportDashboard.viewCurrentScopeValue0": "当前范围：{value0}",
  "reportDashboard.viewShareDenominatorTotalValue1ForValue0TheSameBusinessSourceAndCurrency":
    "占比分母固定为{value0}、同业务来源、同币种的总{value1}",
  "reportDashboard.viewTheDenominatorDoesNotNarrowWithValue0OrModelSelectionCNYAndUSDAreCalculatedSeparately":
    "分母不随{value0}或型号选择缩小，人民币与美元分别计算",
  "reportDashboard.viewNoAmountDataForThisDateRange":
    "当前时间范围暂无金额数据",
  "reportDashboard.viewBusinessTrendsAndComposition": "业务趋势与构成",
  "reportDashboard.viewViewValue0QuantityChangesAndCompositionByBusinessSource":
    "查看{value0}数量变化和不同业务来源的数量结构",
  "reportDashboard.viewValue0QuantityTrend": "{value0}数量趋势",
  "reportDashboard.viewValidDetailQuantitiesGroupedByValue0Month":
    "按{value0}月份汇总有效明细数量",
  "reportDashboard.viewValue0UnitValue1": "{value0}单位：{value1}",
  "reportDashboard.viewALogarithmicScaleIsUsedForLargeMonthlyDifferencesLabelsShowActualQuantities":
    "月份差异较大，已使用对数刻度，数值标签仍为实际数量",
  "reportDashboard.viewNoTrendData": "暂无趋势数据",
  "reportDashboard.viewQuantityByBusinessSource": "数量业务构成",
  "reportDashboard.viewValue0QuantityShareByBusinessSource":
    "各类业务{value0}数量占比",
  "reportDashboard.viewTotalValue0": "{value0}总量",
  "reportDashboard.viewAmountAnalysisAndValue0Ranking":
    "金额分析与{value0}排行",
  "reportDashboard.viewValue0CompositionAndTopValue1InTheOriginalCurrency":
    "按原始币种展示{value0}构成与头部{value1}",
  "reportDashboard.viewBusinessValue0": "业务{value0}",
  "reportDashboard.viewSameCurrencyComparisonNoExchangeRateConversion":
    "同币种比较，未进行汇率折算",
  "reportDashboard.viewValue0RecordsValue1Value2":
    "{value0} 条 · {value1} {value2}",
  "reportDashboard.viewRankedInTheSelectedCurrencyUsingOriginalAmounts":
    "按所选币种排名，保留原始金额口径",
  "reportDashboard.viewModelsAndDataCompleteness": "型号与数据完整性",
  "reportDashboard.viewModelPopularityAndCoverageOfKeyBusinessFields":
    "补充型号热度以及关键业务字段覆盖情况",
  "reportDashboard.viewTop6Value0Models": "{value0}型号 TOP 6",
  "reportDashboard.viewTop5Value0Models": "{value0}型号 TOP 5",
  "reportDashboard.viewModelPopularityByValue0Quantity":
    "按{value0}数量汇总型号热度",
  "reportDashboard.viewPaidRecords": "已收款明细",
  "reportDashboard.viewValue0Records": "{value0} 条",
  "reportDashboard.viewInvoicedRecords": "已开票明细",
  "reportDashboard.viewRecordsAwaitingPayment": "待收款明细",
  "reportDashboard.viewCustomerOrderProvided": "已填客户订单",
  "reportDashboard.viewShipmentDetailsProvided": "已填出货信息",
  "reportDashboard.viewReceivingBankProvided": "已填收款银行",
  "reportDashboard.viewPurchaseCostIncludingTax": "含税采购成本",
  "reportDashboard.viewPurchaseCostExcludingTax": "不含税采购成本",
  "reportDashboard.viewTaxDifference": "税额差异",
  "reportDashboard.viewPaymentDetailsProvided": "已填付款信息",
  "reportDashboard.viewWarehouseReceiptProvided": "已填入仓单号",
  "reportDashboard.viewInputInvoiceDateProvided": "已填进项票日期",
  "reportDashboard.viewCompleteValue0Details": "{value0}完整明细",
  "reportDashboard.viewShowingValue0Value1Records":
    "当前显示 {value0} / {value1} 条",
  "reportDashboard.viewSearchSupplierModelOrderNo": "搜索供应商、型号、订单号…",
  "reportDashboard.viewDateAndBusinessSourceArePinnedScrollHorizontallyForMoreFieldsSelectARowForFullDetails":
    "已固定日期和业务来源，左右滚动查看更多字段；点击行查看完整信息",
  "reportDashboard.viewBusinessSource": "业务来源",
  "reportDashboard.viewNo": "序号",
  "reportDashboard.viewGoodsName": "货物名称",
  "reportDashboard.viewQuantity": "数量",
  "reportDashboard.viewUnitPrice": "单价",
  "reportDashboard.viewSalesAmount": "销售金额",
  "reportDashboard.viewTotalAmount": "总金额",
  "reportDashboard.viewBusinessType": "业务类型",
  "reportDashboard.viewSalesperson": "业务员",
  "reportDashboard.viewReceivingBank": "收款银行",
  "reportDashboard.viewPaymentMode": "付款模式",
  "reportDashboard.viewCustomerOrderNo": "客户订单号",
  "reportDashboard.viewShipmentTimeMethod": "出货时间/方式",
  "reportDashboard.viewRemarks": "备注",
  "reportDashboard.viewActions": "操作",
  "reportDashboard.viewView": "查看",
  "reportDashboard.viewBusinessRecords": "业务记录",
  "reportDashboard.viewViewOriginalShipmentReturnAndBusinessConfigurationRecords":
    "集中查看出货、退货和业务配置原始记录",
  "reportDashboard.viewAddShipmentReturn": "新增出货/退货",
  "reportDashboard.viewAddConfiguration": "新增配置",
  "reportDashboard.viewShipmentReturnRecords": "出货/退货记录",
  "reportDashboard.viewQuantityAwaitingReturn": "待退货数量",
  "reportDashboard.viewValue0Pcs": "{value0} 件",
  "reportDashboard.viewRecordsToCheck": "待核对记录",
  "reportDashboard.viewValue0Items": "{value0} 项",
  "reportDashboard.viewBusinessConfiguration": "业务配置",
  "reportDashboard.viewFromSheet4ReferenceQuantityPackagingDetailsRemarksAndStatus":
    "来自 Sheet4，完整展示单号、数量、包装说明、备注和状态",
  "reportDashboard.viewHReferenceAdjustment": "H单号/调整项",
  "reportDashboard.viewPackagingDetails": "包装明细",
  "reportDashboard.viewStatus": "状态",
  "reportDashboard.viewPackagingCheck": "包装校验",
  "reportDashboard.viewDifferenceValue0Pcs": "差 {value0} 件",
  "reportDashboard.viewMatched": "一致",
  "reportDashboard.viewBusinessConfigurationRecords": "业务配置记录",
  "reportDashboard.viewFromSheet1BusinessTypeSalespersonAndPaymentModeFromTheSameSourceRow":
    "来自 Sheet1，按原表同行展示业务类型、业务员和付款模式",
  "reportDashboard.viewValue0RecordsInTotal": "共 {value0} 条",
  "reportDashboard.viewSourceRowNo": "原表行号",
  "reportDashboard.viewNoConfiguration": "暂无配置",
  "reportDashboard.viewConfigurationFollowsSourceRowsEmptyCellsRemainEmptyValuesAreNotShiftedToFillGaps":
    "业务配置按原表同行对应；空单元格保留为空，不参与错位补齐。",
  "reportDashboard.viewSourceWorksheets": "原始工作表",
  "reportDashboard.viewAllExcelWorksheetsAreRetainedForSourceVerification":
    "保留 Excel 全部工作表内容，便于反向核对",
  "reportDashboard.viewSourceValue0RowsValue1ColumnsHeaderDetectedAtRowValue2":
    "原表 {value0} 行 × {value1} 列 · 已识别第 {value2} 行为表头",
  "reportDashboard.viewSemanticHeadersScrollHorizontallyToViewAllValue0Columns":
    "表头已语义化，左右滚动可查看工作表全部 {value0} 列",
  "reportDashboard.viewEdit": "编辑",
  "reportDashboard.viewThisWorksheetIsEmpty": "当前工作表为空",
  "reportDashboard.viewParsingComplete": "解析完成",
  "reportDashboard.viewWorksheet": "工作表",
  "reportDashboard.viewValue0Details": "{value0}明细",
  "reportDashboard.viewItemsToCheck": "待核对项",
  "reportDashboard.viewImportMode": "导入方式",
  "reportDashboard.viewReplaceCurrentData": "覆盖当前数据",
  "reportDashboard.viewAppendAndDeduplicate": "追加并去重",
  "reportDashboard.viewValue0RowValue1": "{value0} 第{value1}行",
  "reportDashboard.viewCancel": "取消",
  "reportDashboard.viewConfirmImport": "确认导入",
  "reportDashboard.viewAddReportData": "新增报表数据",
  "reportDashboard.viewShipmentReturn": "出货/退货",
  "reportDashboard.viewBasicInformation": "基础信息",
  "reportDashboard.viewEnterQuantity": "请输入数量",
  "reportDashboard.viewEnterUnitPrice": "请输入单价",
  "reportDashboard.viewOptional": "可留空",
  "reportDashboard.viewIfEmptyCalculateQuantityUnitPrice":
    "留空按数量 × 单价计算",
  "reportDashboard.viewBusinessInformation": "业务信息",
  "reportDashboard.viewSettlementAndRemarks": "结算与备注",
  "reportDashboard.viewShipmentAndReturnDetails": "出货与退货信息",
  "reportDashboard.viewRecordStatus": "记录状态",
  "reportDashboard.viewNormal": "正常",
  "reportDashboard.viewAwaitingReturn": "待退货",
  "reportDashboard.viewShipmentReduction": "减出货",
  "reportDashboard.viewForExample15004Packs": "如：1500*4包",
  "reportDashboard.viewForExampleFundedPurchasing": "如：垫资代采",
  "reportDashboard.viewEnterSalesperson": "请输入业务员",
  "reportDashboard.viewForExampleCollectionAndPaymentOnBehalf": "如：代收代付",
  "reportDashboard.viewSaveAndRefreshDashboard": "保存并刷新看板",
  "reportDashboard.viewDetailsToCheck": "待核对详情",
  "reportDashboard.viewValue0RowValue1Label": "{value0} · 第 {value1} 行",
  "reportDashboard.viewToBeConfirmed": "待确认",
  "reportDashboard.viewBusinessReference": "业务编号",
  "reportDashboard.viewEnteredValue": "填写值",
  "reportDashboard.viewCalculatedValue": "计算值",
  "reportDashboard.viewDifference": "差异",
  "reportDashboard.viewReasonForChecking": "核对原因",
  "reportDashboard.viewCheckShipment": "前往出货核对",
  "reportDashboard.viewEditSourceData": "编辑原始数据",
  "reportDashboard.viewWorksheetValue0": "工作表：{value0}",
  "reportDashboard.viewSourceRowValue0": "原表行号：{value0}",
  "reportDashboard.viewBusinessIdentifierValue0": "业务标识：{value0}",
  "reportDashboard.viewImportAndChangeHistory": "导入与修改记录",
  "reportDashboard.viewImportHistory": "导入记录",
  "reportDashboard.viewValue0Value1Records": "{value0} {value1} 条",
  "reportDashboard.viewValue0Shipments": "出货 {value0} 条",
  "reportDashboard.viewValue0ItemsToCheckLabel": "待核对 {value0} 项",
  "reportDashboard.viewNoImportHistory": "暂无导入记录",
  "reportDashboard.viewChangeHistory": "修改记录",
  "reportDashboard.viewDataChange": "数据修改",
  "reportDashboard.viewOperatorValue0": "操作人：{value0}",
  "reportDashboard.viewDataOwnerValue0": "数据归属：{value0}",
  "reportDashboard.viewNoChangeHistory": "暂无修改记录",
  "reportDashboard.viewCNYUnclassified": "人民币／待分类",
  "reportDashboard.viewCountedByCompletedOrderProductDetailRecordsNotContracts":
    "按交易完成订单的商品明细记录统计，不等同于合同数",
  "reportDashboard.viewDeduplicatedByCustomerSupplierIDEntitiesWithTheSameNameAreCountedSeparately":
    "按客户/供应商主体ID去重，同名不同主体分别计数",
  "reportDashboard.viewDifferentQuantityUnitsAreNotAddedTogether":
    "不同数量单位不相加",
  "reportDashboard.viewAllTime": "全部时间",
  "reportDashboard.viewMonthly": "按月",
  "reportDashboard.viewQuarterly": "按季度",
  "reportDashboard.viewHalfYearly": "按半年",
  "reportDashboard.viewYearly": "按年",
  "reportDashboard.viewCustom": "自定义",
  "reportDashboard.viewCustomPeriod": "自定义时间",
  "reportDashboard.viewAllValue0": "全部{value0}",
  "reportDashboard.viewAllValue0Models": "全部{value0}型号",
  "reportDashboard.viewOneValue0OneModel": "单一{value0} + 单一型号",
  "reportDashboard.viewSelectValue0AndModel": "请选择{value0}和型号",
  "reportDashboard.viewSelectValue0AndModelToView": "选择{value0}和型号后查看",
  "reportDashboard.viewOneValue0": "单一{value0}",
  "reportDashboard.viewNoValue0Selected": "未选择{value0}",
  "reportDashboard.viewSelectValue0ToView": "选择{value0}后查看",
  "reportDashboard.viewOneProductModel": "单一产品型号",
  "reportDashboard.viewNoModelSelected": "未选择型号",
  "reportDashboard.viewSelectAModelToView": "选择型号后查看",
  "reportDashboard.viewValidValue0Details": "有效{value0}明细",
  "reportDashboard.viewBlankExcelRowsWithoutAValidQuantityOrAmountAreExcluded":
    "已排除 Excel 中没有有效数量或金额的空白预留行",
  "reportDashboard.viewPartnerValue0": "合作{value0}",
  "reportDashboard.viewValue0Entities": "{value0} 家",
  "reportDashboard.viewDeduplicatedByValue0Name": "按{value0}名称去重统计",
  "reportDashboard.viewTotalValue0Quantity": "{value0}总数量",
  "reportDashboard.viewTotalCNYSales": "人民币销售额合计",
  "reportDashboard.viewTotalCNYPurchaseCost": "人民币采购成本合计",
  "reportDashboard.viewTotalUSDSales": "美元销售额合计",
  "reportDashboard.viewTotalUSDPurchaseCost": "美元采购成本合计",
  "reportDashboard.viewCNYCashBusiness": "RMB现金业务",
  "reportDashboard.viewCNYTaxInclusiveBusiness": "RMB含税业务",
  "reportDashboard.viewCNYCash": "RMB现金",
  "reportDashboard.viewCNYTaxInclusive": "RMB含税",
  "reportDashboard.viewSales": "销售",
  "reportDashboard.viewPurchasing": "采购",
  "reportDashboard.viewDate": "日期",
  "reportDashboard.viewModel": "型号",
  "reportDashboard.viewOrderDate": "订单日期",
  "reportDashboard.viewOrderingCompany": "做单公司",
  "reportDashboard.viewSalesQuantity": "销售数量",
  "reportDashboard.viewSalesUnitPrice": "销售单价",
  "reportDashboard.viewSalesAmountExcludingTax": "不含税销售金额",
  "reportDashboard.viewPaymentReceivedAt": "收款时间",
  "reportDashboard.viewInvoiceDate": "开票日期",
  "reportDashboard.viewWarehouseReceiptNo": "入仓号",
  "reportDashboard.viewPurchaseDate": "采购日期",
  "reportDashboard.viewSourceColumnC": "原表字段 C",
  "reportDashboard.viewOrderingAccount": "下单账户",
  "reportDashboard.viewOrderingAccountSourceColumnC": "下单账户 / 原表字段 C",
  "reportDashboard.viewPurchaseModel": "采购型号",
  "reportDashboard.viewPurchaseQuantity": "采购数量",
  "reportDashboard.viewPurchaseUnitPrice": "采购单价",
  "reportDashboard.viewCostExcludingTax": "不含税成本",
  "reportDashboard.viewPaymentTime": "付款时间",
  "reportDashboard.viewInputInvoiceDate": "进项票日期",
  "reportDashboard.viewPurchaseWarehouseReceiptNo": "采购入仓单号",
  "reportDashboard.viewSalesShareAnalysis": "销售占比分析",
  "reportDashboard.viewPurchaseCostShareAnalysis": "采购成本占比分析",
  "reportDashboard.viewPaymentAndInvoiceCoverage": "收款与开票覆盖",
  "reportDashboard.viewTaxAndFieldCoverage": "税额与字段覆盖",
  "reportDashboard.viewPaymentInvoiceAndCustomerOrderInformation":
    "同步展示收款、开票和客户订单信息",
  "reportDashboard.viewTaxInclusiveBusinessCostsAndTextFieldCompleteness":
    "含税业务成本及文本字段完整性",
  "reportDashboard.viewLogScale": "对数刻度 · ",
  "reportDashboard.viewNotConnected": "待接入",
  "reportDashboard.viewTheSelectedCompanyIsOutsideTheAuthorizedOptions":
    "所选公司不在当前授权选项中",
  "reportDashboard.viewTheSelectedCustomerIsOutsideTheCurrentScope":
    "所选客户不在当前范围中",
  "reportDashboard.viewYourAccountDoesNotHavePermissionToViewReportData":
    "当前账号无报表数据查看权限",
  "reportDashboard.viewReportDataAccessHasNotBeenConfiguredForYourAccount":
    "当前账号暂未配置报表数据权限",
  "reportDashboard.viewJSONCompletedOrders": "JSON · 交易完成订单",
  "reportDashboard.viewQueriedAtValue0": "查询时间 {value0}",
  "reportDashboard.viewExportFailed": "导出失败",
  "reportDashboard.viewSelectACompanyBeforeLoadingLegacyWorksheetsForChecking":
    "请先选定公司，再按需读取旧工作表核对",
  "reportDashboard.viewLegacyReportVerification": "旧报表核对",
  "reportDashboard.viewCouldNotLoadLegacyWorksheetsForChecking":
    "旧工作表核对读取失败",
  "reportDashboard.viewPurchaseAndSaleOnBehalf": "代采代销",
  "reportDashboard.viewPurchasingWithAdvancePayment": "代采垫付",
  "reportDashboard.viewFactoringCredit": "保理放账",
  "reportDashboard.viewReceivablesReport": "应收报表",
  "reportDashboard.viewSalesScaleCustomerCompositionPaymentsInvoicesAndSourceWorksheets":
    "销售规模、客户构成、收款开票与原始工作表统一查看",
  "reportDashboard.viewPayablesReport": "应付报表",
  "reportDashboard.viewPurchasingShipmentChecksBusinessDictionariesAndSourceWorksheets":
    "采购业务、出货核对、业务字典与原始工作表统一查看",
  "reportDashboard.viewCalculatedPackagingQuantityDiffersFromTheEnteredQuantity":
    "包装计算与填写数量存在差异",
  "reportDashboard.viewAmountDiffersFromQuantityUnitPrice":
    "金额与数量 × 单价存在差异",
  "reportDashboard.viewOverview": "综合看板",
  "reportDashboard.viewSourceData": "原始数据",
  "reportDashboard.viewYourAccountCanOnlyViewReports": "当前账号仅可查看报表",
  "reportDashboard.viewAllSalesModels": "全部销售型号",
  "reportDashboard.viewAllPurchaseModels": "全部采购型号",
  "reportDashboard.viewTotalSalesQuantity": "销售总数量",
  "reportDashboard.viewTotalPurchaseQuantity": "采购总数量",
  "reportDashboard.viewValue0NotProvided": "未标记{value0}",
  "reportDashboard.viewPackagingQuantityDiffersByValue0Pcs":
    "包装计算与填写数量相差 {value0} 件",
  "reportDashboard.viewDataUpdatedButThisBrowserCannotSaveItPersistently":
    "数据已更新，但当前浏览器无法持久保存",
  "reportDashboard.viewThisWorksheetIsReadOnly": "当前工作表仅支持只读查看",
  "reportDashboard.viewThisAccountOrWorksheetCannotBeEdited":
    "当前账号或工作表没有编辑权限",
  "reportDashboard.viewNoChangesToSave": "没有需要保存的修改",
  "reportDashboard.viewSourceWorksheetNotFound": "原始工作表不存在",
  "reportDashboard.viewCurrentUser": "当前用户",
  "reportDashboard.viewSourceDataUpdatedAndDashboardRecalculated":
    "原始数据已更新，看板已重新计算",
  "reportDashboard.viewCouldNotSave": "保存失败",
  "reportDashboard.viewOnlyXlsxOrXlsFilesAreSupported":
    "仅支持 .xlsx 或 .xls 文件",
  "reportDashboard.viewCouldNotParseExcelCheckTheFileFormat":
    "Excel 解析失败，请检查文件格式",
  "reportDashboard.viewRestoreSourceFile": "恢复源文件",
  "reportDashboard.viewCouldNotRestore": "恢复失败",
  "reportDashboard.viewUpdatedValue0": "{value0} 更新",
  "reportDashboard.viewCNY": "人民币",
  "reportDashboard.viewUSD": "美元",
  "reportDashboard.viewUnnamedColumnValue0": "未命名列 {value0}",
  "reportDashboard.readOnly": "只读",
  "reportDashboard.errorModelLimitExceeded": "型号范围过大，请缩小筛选范围",
  "reportDashboard.errorQuantityTrendLimitExceeded":
    "数量趋势范围过大，请缩小范围",
  "reportDashboard.exportUnitPrice": "成交单价",
  "reportDashboard.exportSalesperson": "原报表业务员",
  "reportDashboard.exportContractNo": "合同编号（原客户订单列）",
  "reportDashboard.exportPaymentConfirmedAt": "确认收款时间",
  "reportDashboard.exportInvoiceUploadedAt": "发票上传时间",
  "reportDashboard.exportShippedAt": "发货时间",
  "reportDashboard.exportPaymentType": "付款业务类型编码",
  "reportDashboard.exportSourceRemarks": "原合同/订单备注",
  "reportDashboard.selectYear": "选择年份",
  "reportDashboard.timeAxisUnit": "筛选单位",
  "reportDashboard.timeAxisDay": "天",
  "reportDashboard.timeAxisWeek": "周",
  "reportDashboard.timeAxisMonth": "月",
  "reportDashboard.timeAxisQuarter": "季",
  "reportDashboard.timeAxisYear": "年",
  "reportDashboard.timeAxisDailyUnavailable":
    "当前服务未提供日级趋势，请更新 MTS API 后查看日／周／季／年趋势",
  "reportDashboard.categoryTopSix": "分类产品 TOP 6",
  "reportDashboard.categoryTopFive": "分类产品 TOP 5",
  "reportDashboard.rankPrevious": "上一组",
  "reportDashboard.rankNext": "下一组",
  "reportDashboard.categoryDescription":
    "按当前筛选范围、同单位数量排行；比例以该分类全部料号为分母",
  "reportDashboard.categoryWAFER": "WAFER",
  "reportDashboard.categoryFLASH": "FLASH颗粒",
  "reportDashboard.categoryDDR": "DDR颗粒",
  "reportDashboard.categorySSD": "SSD",
  "reportDashboard.categoryMEMORYMODULE": "内存条",
  "reportDashboard.categoryUnit": "数量单位",
  "reportDashboard.businessSupplyChain": "供应链订单",
  "reportDashboard.businessTrade": "贸易订单",
  "reportDashboard.businessUnclassified": "待分类",
  "reportDashboard.categoryUnconverted":
    "有 {count} 条记录使用包装或未识别单位，缺少换算依据，未计入分类数量排行。",
  "reportDashboard.categoryLoading": "正在读取分类排行…",
  "reportDashboard.categoryReadFailed": "分类读取失败，请重试",
  "reportDashboard.categoryEmpty": "当前筛选范围内，该类型没有交易完成的订单",
  "reportDashboard.categoryRetry": "重试",
  "reportDashboard.categoryAwaitingQuery": "等待当前筛选查询完成",
  "reportDashboard.categoryUnknownQuantity":
    "存在数量缺失，比例不可作为完整业务占比",
  "reportDashboard.quantityChartLabel": "{value0}数量趋势图",
  "reportDashboard.businessDate": "{value0}日期",
  "reportDashboard.packagingDifferencesHint":
    "发现 {value0} 条包装数量差异，请在出货/退货记录的“包装校验”列核对。",
  "reportDashboard.paid": "已收款",
  "reportDashboard.shipmentRecords": "出货记录",
  "reportDashboard.importDifferencesHint":
    "发现 {value0} 项差异，导入后会保留并提示。",
  "reportDashboard.businessLabel": "{value0}业务",
  "reportDashboard.businessQuantity": "{value0}数量",
  "reportDashboard.businessUnitPrice": "{value0}单价",
  "reportDashboard.businessFullRecord": "{value0}记录完整信息",
  "reportDashboard.validationDifferencesHint":
    "发现 {value0} 项数据差异，请结合原始工作表确认。",
  "reportDashboard.shipmentQuantityCheck": "出货数量核对",
  "reportDashboard.valueCheck": "{value0}核对",
  "reportDashboard.enterField": "请输入{value0}",
  "reportDashboard.dateRangeText": "{value0} 至 {value1}",
  "reportDashboard.errorUnitLimitExceeded": "数量单位范围过大，请缩小筛选范围",
  "reportDashboard.unitSinglePiece": "片",
  "reportDashboard.salesCompany": "销售公司",
  "reportDashboard.orderingCompany": "下单公司",
  "reportDashboard.allSalesCompanies": "全部销售公司",
  "reportDashboard.allOrderingCompanies": "全部下单公司",
  "reportDashboard.receivablesTemplateFilename": "应收业务数据导入模板.xlsx",
  "reportDashboard.payablesTemplateFilename": "应付业务数据导入模板.xlsx",
  "reportDashboard.receivablesExportFilename": "应收业务数据_{date}.xlsx",
  "reportDashboard.payablesExportFilename": "应付业务数据_{date}.xlsx",
  "reportDashboard.errorCategoryInvalid": "产品分类无效",
  "reportDashboard.businessFactsTitle": "真实订单业务记录",
  "reportDashboard.businessLegacyDeferred":
    "原工作表业务记录尚未读取，可按需使用上方核对入口；未读取不代表出货、退货数量为零。",
  "reportDashboard.businessFactsScope":
    "按订单创建日期和主看板相同范围读取；以下状态编码及业务事实来自订单，不是原始工作表配置",
  "reportDashboard.businessFactsCompany": "本方公司",
  "reportDashboard.businessFactsModel": "料号",
  "reportDashboard.businessFactsSalesperson": "原报表业务员",
  "reportDashboard.businessFactsShipStatus": "发货状态编码",
  "reportDashboard.businessFactsCarrier": "物流公司",
  "reportDashboard.businessFactsTracking": "物流单号",
  "reportDashboard.businessFactsUnavailable":
    "实际出货数量、退货、入仓号、客户PO和贸易／供应链分类尚未具备可靠订单归属，不以订单数量或固定值代填。下方原工作表记录仅供核对。",
  "reportDashboard.categoryResponseInvalid": "分类排行返回格式错误",
});

export const messages = Object.freeze({ ...flows, ...reportDashboard });
